import Raven from 'raven-js'

export const getDecodedRemarks = input => {
  let originalInput = input
  let decodedRemarks = []
  let initialUppercase = str => {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
  input = input.replace("RMK", "")
  remarkSections.map(rec => {
    let matches = input.match(rec.regex)
    if(matches && matches.length > 0) {
      matches.map(mtch => {
        decodedRemarks.push(initialUppercase(rec.decoder(mtch)))
        input = input.replace(mtch, "")
        return undefined
      })
    }
    return undefined
  })

  //log remarks that aren't properly decoded
  if(input.trim() !== "") {
    Raven.captureMessage('Encounterd improperly-decoded remarks', {
      level: 'info',
      extra: {
        raw: originalInput,
        remaining: input,
        decodedRemarks
      }
    })
  }

  return decodedRemarks
}

const remarkSections = [
  {
    //automated metar type
    regex: /AO[\d]A?/g,
    decoder: input => autoTypeDecoder(input)
  },
  {
    //peak wind
    regex: /PK WND [\d]{5,6}\/(?:[\d]{2}){1,2}/g,
    decoder: input => peakWindDecoder(input)
  },
  {
    //wind shift
    regex: /WSHFT (?:[\d]{2}){1,2}(?: FROPA)?/g,
    decoder: input => windShiftDecoder(input)
  },
  {
    //tower visibility
    regex: /TWR VIS (?:[0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/g,
    decoder: input => towerVisibilityDecoder(input)
  },
  {
    //surface visibility
    regex: /SFC VIS (?:[0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/g,
    decoder: input => surfaceVisibilityDecoder(input)
  },
  {
    //variable prevailing visibility
    regex: /VIS (?:[0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})V(?:[0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/g,
    decoder: input => variableVisibilityDecoder(input)
  },
  {
    //sector visibility
    regex: /VIS (?:NE|SE|SW|NW|N|E|S|W) (?:[0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/g,
    decoder: input => sectorVisibilityDecoder(input)
  },
  {
    //visibility at second location
    regex: /VIS (?:[0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3}) (?:[A-Z].*?)(?: |$)/gm,
    decoder: input => visibilityLocationDecoder(input)
  },
  {
    //lightning
    regex: /(?:FQT|FRQ|OCNL|CONS)? ?LTG(?:CG|IC|CC|CA|CW){0,3} ?(?:OVHD|OHD|VC|DSNT)? ?(?:ALQDS|ALQS|NE-?|SE-?|SW-?|NW-?|N-?|E-?|S-?|W-?){0,2}(?: |$)/gm,
    decoder: input => lightningDecoder(input)
  },
  {
    //begin or end of precipitation
    regex: /(?:(?:[A-Z]{2}){1,2})(?:[BE](?:[0-9]{2}){1,2})+/g,
    decoder: input => precipitationBEDecoder(input)
  },
  {
    //thunderstorm location
    regex: /TS (?:NE|SE|SW|NW|N|E|S|W)(?: MOV )?(?:NE|SE|SW|NW|N|E|S|W)?/g,
    decoder: input => thunderstormLocationDecoder(input)
  },
  {
    //hailstone size
    regex: /GR (?:[0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/g,
    decoder: input => hailstoneSizeDecoder(input)
  },
  {
    //virga
    regex: /VIRGA ?(?:OVHD|OHD|VC|DSNT)? ?(?:ALQDS|NE-?|SE-?|SW-?|NW-?|N-?|E-?|S-?|W-?){0,2}(?: ?|$)/gm,
    decoder: input => virgaDecoder(input)
  },
  {
    //variable ceiling height
    regex: /CIG (?:[0-9]{3})V(?:[0-9]{3})/g,
    decoder: input => variableCeilingHeightDecoder(input)
  },
  {
    //obscuration
    regex: /(?:[A-Z]{2}) (?:FEW|SCT|BKN|OVC) ?(?:[0-9]{3})/g,
    decoder: input => obscurationDecoder(input)
  },
  {
    //variable sky condition
    regex: /(?:FEW|SCT|BKN|OVC)(?:[0-9]{3}) V (?:FEW|SCT|BKN|OVC)/g,
    decoder: input => variableSkyConditionDecoder(input)
  },
  {
    //significant cloud types
    regex: /(?:CBMAM|CB|TCU|ACC|SCSL|ACSL|CCSL|APRNT ROTOR CLD)(?: DSNT)? ?(?:NE|SE|SW|NW|N|E|S|W)?-?(?:NE|SE|SW|NW|N|E|S|W)?(?: MOV )?(?:NE|SE|SW|NW|N|E|S|W)?/g,
    decoder: input => significantCloudTypeDecoder(input)
  },
  {
    //ceiling height at secondary location
    regex: /CIG (?:[0-9]{3}) (?:[A-Za-z0-9]*)/g,
    decoder: input => ceilingHeightSecondaryLocationDecoder(input)
  },
  {
    //pressur rising or falling rapidly
    regex: /(?:PRESRR|PRESFR)/g,
    decoder: input => pressureRiseFallDecoder(input)
  },
  {
    //sea level pressure
    regex: / SLP(?:[0-9]{3})/g,
    decoder: input => seaLevelPressureDecoder(input)
  },
  {
    //aircraft mishap
    regex: /ACFT MSHP/g,
    decoder: input => aircraftMishapDecoder(input)
  },
  {
    //no speci reports
    regex: /NOSPECI/g,
    decoder: input => nospeciDecoder(input)
  },
  {
    //snow increase raplidy
    regex: /SNINCR([0-9]{1,2})\/([0-9]{1,2})/g,
    decoder: input => snowIncreaseRapidlyDecoder(input)
  },
  {
    //hourly precipitation amount
    regex: / P(?:[0-9]{4})/g,
    decoder: input => hourlyPrecipitationDecoder(input)
  },
  {
    //3-/6- hour precipitation amount
    regex: / 6(?:[0-9]{4})/g,
    decoder: input => threeSixHourPrecipitationDecoder(input)
  },
  {
    //24 hour precipitation amount
    regex: / 7(?:[0-9]{4})/g,
    decoder: input => twentyFourHourPrecipitationDecoder(input)
  },
  {
    //snow depth on ground
    regex: / 4\/(?:[0-9]{3})/g,
    decoder: input => snowDepthDecoder(input)
  },
  {
    //water equivalent snow depth
    regex: / 933(?:[0-9]{3})/g,
    decoder: input => waterEquivalentSnowDepthDecoder(input)
  },
  {
    //cloud type
    regex: / 8\/(?:[0-9\/]{3})/g,
    decoder: input => cloudTypeDecoder(input)
  },
  {
    //sunshine duration
    regex: / 98(?:[0-9]{3})/g,
    decoder: input => sunshineDurationDecoder(input)
  },
  {
    //hourly temperature dewpoint
    regex: / T(?:[0-9]{8})/g,
    decoder: input => hourlyTempDewDecoder(input)
  },
  {
    //6 hour max temperature
    regex: / 1(?:[0-9]{4})/g,
    decoder: input => sixHourMaxTemperatureDecoder(input)
  },
  {
    //6 hour min temperature
    regex: / 2(?:[0-9]{4})/g,
    decoder: input => sixHourMinTemperatureDecoder(input)
  },
  {
    //24 hour min/max temperature
    regex: / 4(?:[0-9]{8})/g,
    decoder: input => twentyFourMaxMinTemperatureDecoder(input)
  },
  {
    //3 hour pressure tendency
    regex: / 5(?:[0-9]{4})/g,
    decoder: input => threeHourPressureTendencyDecoder(input)
  },
  {
    //not operable sensors
    regex: /(?:RVRNO|PWINO|PNO|FZRANO|TSNO|SLPNO)/g,
    decoder: input => notOperableSensorDecoder(input)
  },
  {
    //secondary sensor operability
    regex: /(?:VISNO|CHINO) (?:[A-Za-z0-9]*)/g,
    decoder: input => notOperableSecondaryLocationSensorDecoder(input)
  },
  {
    //maintenance indicator
    regex: /\$/g,
    decoder: input => maintenanceIndicatorDecoder(input)
  }
]

const autoTypeDecoder = input => {
  switch(input) {
    case "AO2":
      return "Automated with precipitation sensor"
    case "AO1":
      return "Automated without precipitation sensor"
    case "AO2A":
      return "Automated with precipitation sensor, human augmented"
    case "AO1A":
      return "Automated without precipitation sensor, human augmented"
    default:
      return input
  }
}

const peakWindDecoder = input => {
  let regex = /PK WND ([0-9]{3})([0-9]{2,3})\/([0-9]{2})?([0-9]{2})/
  let groups = regex.exec(input)
  let bearing = groups[1]
  let speed = groups[2]
  let hour = groups[3]
  let minutes = groups[4]
  let time
  if(!hour) {
    time = minutes + " mins after the hour"
  } else {
    time = hour + ":" + minutes + " UTC"
  }
  return "Peak wind bearing " + bearing + "° at " + speed + "kts, " + time
}

const windShiftDecoder = input => {
  let regex = /WSHFT ([0-9]{2})?([0-9]{2}) ?(FROPA)?/
  let groups = regex.exec(input)
  let hour = groups[1]
  let minutes = groups[2]
  let time
  if(!hour) {
    time = minutes + " mins after the hour"
  } else {
    time = hour + ":" + minutes + " UTC"
  }
  let frontalPassage = groups[3]
  if(frontalPassage) {
    frontalPassage = ", frontal passage"
  } else {
    frontalPassage = ""
  }
  return "Wind shift at " + time + frontalPassage
}

const towerVisibilityDecoder = input => {
  let regex = /TWR VIS ([0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/
  let groups = regex.exec(input)
  return "Tower visibility: " + groups[1] + " sm"
}

const surfaceVisibilityDecoder = input => {
  let regex = /SFC VIS ([0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/
  let groups = regex.exec(input)
  return "Surface visibility: " + groups[1] + " sm"
}

const variableVisibilityDecoder = input => {
  let regex = /VIS ([0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})V([0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/
  let groups = regex.exec(input)
  return "Visibility variable from " + groups[1] + " sm to " + groups[2] + " sm"
}

const sectorVisibilityDecoder = input => {
  let regex = /VIS (NE|SE|SW|NW|N|E|S|W) ([0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/
  let groups = regex.exec(input)
  let decodedValue = ""
  switch(groups[1]) {
    case "NE":
      decodedValue += "Northeast"
      break
    case "SE":
      decodedValue += "Southeast"
      break
    case "SW":
      decodedValue += "Southwest"
      break
    case "NW":
      decodedValue += "Northwest"
      break
    case "N":
      decodedValue += "North"
      break
    case "E":
      decodedValue += "East"
      break
    case "S":
      decodedValue += "South"
      break
    case "W":
      decodedValue += "West"
      break
    default:
      break
  }
  decodedValue += " visibility: " + groups[2] + " sm"
  return decodedValue
}

const visibilityLocationDecoder = input => {
  let regex = /VIS ([0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3}) ([A-Z].*?)(?: |$)/
  let groups = regex.exec(input)
  let location = groups[2]
  let visibility = groups[1]
  return location + " visibility: " + visibility + " sm"
}

const lightningDecoder = input => {
  let regex = /(FQT|FRQ|OCNL|CONS)? ?LTG(CG|IC|CC|CA|CW)?(CG|IC|CC|CA|CW)?(CG|IC|CC|CA|CW)? ?(OVHD|OHD|VC|DSNT)? ?(ALQDS|ALQS|NE|SE|SW|NW|N|E|S|W)?-?(NE|SE|SW|NW|N|E|S|W)?(?: |$)/m
  let groups = regex.exec(input)
  let frequency = groups[1]
  let type1 = groups[2]
  let type2 = groups[3]
  let type3 = groups[4]
  let locationQuad = groups[5]
  let location1 = groups[6]
  let location2 = groups[7]

  let decodedString =""

  switch(frequency) {
    case "FQT":
    case "FRQ":
      decodedString += "frequent "
      break
    case "OCNL":
      decodedString += "occasional "
      break
    case "CONS":
      decodedString += "constant "
      break
    default:
      break
  }

  decodedString += "lightning"

  const typeString = input => {
    switch(input) {
      case "CG":
        return "cloud to ground"
      case "IC":
        return "intracloud"
      case "CC":
        return "cloud to cloud"
      case "CA":
        return "cloud to air"
      case "CW":
        return "cloud to water"
      default:
        return ""
    }
  }

  if(type1) {
    decodedString += ", " + typeString(type1)
  }
  if(type2) {
    decodedString += ", " + typeString(type2)
  }
  if(type3) {
    decodedString += ", " + typeString(type3)
  }

  if(locationQuad) {
    switch(locationQuad) {
      case "OVHD":
      case "OHD":
        decodedString += ", overhead"
        break
      case "VC":
        decodedString += ", in the vicinity"
        break
      case "DSNT":
        decodedString += ", distant"
        break
      default:
        break
    }
  }

  if(location1) {
    decodedString += ", " + locationString(location1)
  }

  if(location2) {
    decodedString += " and " + locationString(location2)
  }

  return decodedString
}

const precipitationBEDecoder = input => {
  let decodedString = ""
  let regex = /([A-Z]{2})?([A-Z]{2})/
  let groups = regex.exec(input)

  if(groups[2]) {
    decodedString += precipitationDecoder(groups[2])
  }

  if(groups[1]) {
    decodedString += ", " + precipitationDecoder(groups[1])
  }

  let begEndRegex = /([BE])([0-9]{2})?([0-9]{2})/g
  let begEndMatches = input.match(begEndRegex)
  begEndMatches.map(rec => {
    let bEGroups = begEndRegex.exec(input)
    bEGroups[1] === "B" ? decodedString += ", beginning " : decodedString += ", ending "

    if(bEGroups[2]) {
      decodedString += bEGroups[2] + ":"
    }

    if(bEGroups[3]) {
      decodedString += bEGroups[3]
      if(bEGroups[2]) {
        decodedString += " UTC"
      } else {
        decodedString += " mins after the hour"
      }
    }
    return undefined
  })
  return decodedString
}

const locationString = input => {
  switch(input) {
    case "ALQDS":
    case "ALQS":
      return "all quadrants"
    case "NE":
      return "northeast"
    case "SE":
      return "southeast"
    case "SW":
      return "southwest"
    case "NW":
      return "northwest"
    case "N":
      return "north"
    case "E":
      return "east"
    case "S":
      return "south"
    case "W":
      return "west"
    default:
      return input
  }
}

const precipitationDecoder = input => {
  switch(input) {
    case "FC": return "funnel cloud"
    case "MI": return "shallow"
    case "BL": return "blowing"
    case "BC": return "patches"
    case "PR": return "partial"
    case "DR": return "drifting"
    case "TS": return "thunderstorm"
    case "FZ": return "freezing"
    case "DZ": return "drizzle"
    case "IC": return "ice crystals"
    case "UP": return "unknown precipitation"
    case "RA": return "rain"
    case "PL": return "ice pellets"
    case "SN": return "snow"
    case "GR": return "hail"
    case "SG": return "snow grains"
    case "GS": return "small hail"
    case "FG": return "fog"
    case "BR": return "mist"
    case "SA": return "sand"
    case "FU": return "smoke"
    case "HZ": return "haze"
    case "VA": return "volcanic ash"
    case "PY": return "spray"
    case "DU": return "widespread dust"
    case "SQ": return "squall"
    case "SS": return "sandstorm"
    case "DS": return "duststorm"
    case "PO": return "sand whirls"
    case "SH": return "showers"
    default: return input
  }
}

const thunderstormLocationDecoder = input => {
  let regex =/TS (NE|SE|SW|NW|N|E|S|W)(?: MOV )?(NE|SE|SW|NW|N|E|S|W)?/
  let groups = regex.exec(input)
  let decodedString = "thunderstorm location: " + locationString(groups[1])
  if(groups[2]) {
    decodedString += ", moving " + locationString(groups[2])
  }
  return decodedString
}

const hailstoneSizeDecoder = input => {
  let regex = /GR ([0-9] [0-9]\/[0-9]|[0-9]\/[0-9]|[0-9]{1,3})/
  let groups = regex.exec(input)
  let decodedString = "Hailstone size: " + groups[1] + " in"
  return decodedString
}

const virgaDecoder = input => {
  let regex = /VIRGA ?(OVHD|OHD|VC|DSNT)? ?(ALQDS|NE|SE|SW|NW|N|E|S|W)?-?(NE|SE|SW|NW|N|E|S|W)?(?: ?|$)/
  let groups = regex.exec(input)
  let locationQuad = groups[1]
  let location1 = groups[2]
  let location2 = groups[3]

  let decodedString = "Virga"

  if(locationQuad) {
    switch(locationQuad) {
      case "OVHD":
      case "OHD":
        decodedString += ", overhead"
        break
      case "VC":
        decodedString += ", in the vicinity"
        break
      case "DSNT":
        decodedString += ", distant"
        break
      default:
        break
    }
  }

  if(location1) {
    decodedString += ", " + locationString(location1)
  }

  if(location2) {
    decodedString += " and " + locationString(location2)
  }
  return decodedString
}

const variableCeilingHeightDecoder = input => {
  let regex = /CIG ([0-9]{3})V([0-9]{3})/
  let groups = regex.exec(input)
  let decodedString = "variable ceiling height: " + groups[1] + " to " + groups[2]
  return decodedString
}

const obscurationDecoder = input => {
  let regex = /([A-Z]{2}) (FEW|SCT|BKN|OVC) ?([0-9]{3})/
  let groups = regex.exec(input)
  let decodedString = "obscuration: " +  precipitationDecoder(groups[1])
    + ", " + groups[2] + " " + groups[3]
  return decodedString
}

const variableSkyConditionDecoder = input => {
  let regex = /(FEW|SCT|BKN|OVC)([0-9]{3}) V (FEW|SCT|BKN|OVC)/
  let groups = regex.exec(input)
  let decodedString = "variable sky condition: " + groups[1] + " and " + groups[3] +
    ", " + groups[2]
  return decodedString
}

const significantCloudTypeDecoder = input => {
  let regex = /(CBMAM|CB|TCU|ACC|SCSL|ACSL|CCSL|APRNT ROTOR CLD)( DSNT)? ?(NE|SE|SW|NW|N|E|S|W)?-?(NE|SE|SW|NW|N|E|S|W)?(?: MOV )?(NE|SE|SW|NW|N|E|S|W)?/
  let groups = regex.exec(input)
  let decodedString = "significant clouds: "
  switch(groups[1]) {
    case "CBMAM":
      decodedString += "cumulonimbus mammatus"
      break
    case "CB":
      decodedString += "cumulonimbus"
      break
    case "TCU":
      decodedString += "towering cumulus"
      break
    case "ACC":
      decodedString += "altocumulus castellanus"
      break
    case "SCSL":
      decodedString += "stratocumulus standing lenticular"
      break
    case "ACSL":
      decodedString += "altocumulus standing lenticular"
      break
    case "CCSL":
      decodedString += "cirrocumulus standing lenticular"
      break
    case "APRNT ROTOR CLD":
      decodedString += "apparent rotor cloud"
      break
    default:
    break
  }

  if(groups[2]) {
    decodedString += " distant"
  }

  if(groups[3]) {
    decodedString += " " + locationString(groups[3])
  }

  if(groups[4]) {
    decodedString += " through " + locationString(groups[4])
  }

  if(groups[5]) {
    decodedString += ", moving " + locationString(groups[5])
  }
  return decodedString
}

const ceilingHeightSecondaryLocationDecoder = input => {
  let regex = /CIG ([0-9]{3}) ([A-Za-z0-9]*)/
  let groups = regex.exec(input)
  let decodedString = "ceiling height at " + groups[2] + ": " + groups[1]
  return decodedString
}

const pressureRiseFallDecoder = input => {
  let regex = /(PRESRR|PRESFR)/
  let groups = regex.exec(input)
  if(groups[1] === "PRESRR") {
    return "pressure rising rapidly"
  }
  return "pressure falling rapidly"
}

const seaLevelPressureDecoder = input => {
  let regex = /SLP([0-9]{3})/
  let groups = regex.exec(input)
  let slpValue = Number(groups[1])
  let decodedString = "sea-level pressure: "
  if(slpValue >= 500) {
    decodedString += "9"
  } else {
    decodedString += "10"
  }
  decodedString += groups[1].substring(0, 2) + "." + groups[1].substring(2, 3) + " hPa"
  return decodedString
}

const aircraftMishapDecoder = input => {
  return "aircraft mishap"
}

const nospeciDecoder = input => {
  return "no special weather reports"
}

const snowIncreaseRapidlyDecoder = input => {
  let regex = /SNINCR([0-9]{1,2})\/([0-9]{1,2})/
  let groups = regex.exec(input)
  let decodedString = "snow increasing rapidly: " + groups[1] + " in per hour, " +
    groups[2] + " in on ground"
  return decodedString
}

const hourlyPrecipitationDecoder = input => {
  let regex = /P([0-9]{4})/
  let groups = regex.exec(input)
  let decodedString = "hourly precipitation: "
  if(groups[1] === "0000") {
    decodedString += "less than 0.01 in"
  } else {
    decodedString += groups[1].substring(0, 2) + "." + groups[1].substring(2, 4) + " in"
  }
  return decodedString
}

const threeSixHourPrecipitationDecoder = input => {
  let regex = /6([0-9]{4})/
  let groups = regex.exec(input)
  let decodedString = "3/6 hour precipitation: "
  if(groups[1] === "0000") {
    decodedString += "less than 0.01 in"
  } else {
    decodedString += groups[1].substring(0, 2) + "." + groups[1].substring(2, 4) + " in"
  }
  return decodedString
}

const twentyFourHourPrecipitationDecoder = input => {
  let regex = /7([0-9]{4})/
  let groups = regex.exec(input)
  let decodedString = "24 hour precipitation: "
  if(groups[1] === "0000") {
    decodedString += "less than 0.01 in"
  } else {
    decodedString += groups[1].substring(0, 2) + "." + groups[1].substring(2, 4) + " in"
  }
  return decodedString
}

const snowDepthDecoder = input => {
  let regex = /4\/([0-9]{3})/
  let groups = regex.exec(input)
  let decodedString = "snow depth: " + groups[1] + " in"
  return decodedString
}

const waterEquivalentSnowDepthDecoder = input => {
  let regex = /933([0-9]{3})/
  let groups = regex.exec(input)
  let decodedString = "water equivalent snow depth: " + groups[1].substring(0, 2) + "." + groups[1].substring(2, 3) + " in"
  return decodedString
}

const cloudTypeDecoder = input => {
  let regex = /8\/([0-9\/])([0-9\/])([0-9\/])/
  let groups = regex.exec(input)

  let low = groups[1]
  let medium = groups[2]
  let high = groups[3]

  let lowCloud = input => {
    switch(input) {
      case "9": return "cumulonimbus capillatus"
      case "8": return "cumulus and stratocumulus at different base levels"
      case "7": return "stratus fractus or cumulus fractus of wet weather"
      case "6": return "stratus nebulosus/fractus of dry weather"
      case "5": return "stratocumulus non-cumulogenitus"
      case "4": return "stratocumulus"
      case "3": return "non-fibrous/non-striated cumulonimbus"
      case "2": return "cumulus mediocris or congestus at same base levels"
      case "1": return "cumulus humilis/fractus of dry weather"
      case "0": return "none"
      case "/": return "unknown"
      default:
        return input
    }
  }

  let mediumCloud = input => {
    switch(input) {
      case "9": return "altocumulus"
      case "8": return "altocumulus castellanus or floccus"
      case "7": return "altocumulus coexisting with altostratus or nimbostratus; altocumulus translucidus/opacus at different base levels; altocumulus opacus"
      case "6": return "altocumulus cumulogenitus or cumulonimbogenitus"
      case "5": return "progressively invading altocumulus"
      case "4": return "continuously changing altocumulus patches"
      case "3": return "altocumulus translucidus"
      case "2": return "sun/moon-blocking altostratus or nimbostratus"
      case "1": return "semi-transparent altostratus"
      case "0": return "none"
      case "/": return "unknown"
      default:
        return input
    }
  }

  let highCloud = input => {
    switch(input) {
      case "9": return "cirrocumulus"
      case "8": return "cirrostratus"
      case "7": return "sky-covering cirrostratus"
      case "6": return "progressively invading cirrostratus more than 45° above horizon"
      case "5": return "progressively invading cirrostratus less than 45° above horizon"
      case "4": return "cirrus uncinus and/or fibratus"
      case "3": return "progressively invading cirrus spissatus"
      case "2": return "cirrus spissatus non-cumulonimbogenitus and cirrus castellanus and/or floccus"
      case "1": return "cirrus fibratus and/or uncinus"
      case "0": return "none"
      case "/": return "unknown"
      default:
        return input
    }
  }

  let decodedString = "clouds: low - " + lowCloud(low) + ", medium - " + mediumCloud(medium) + ", high - " + highCloud(high)
  return decodedString
}

const sunshineDurationDecoder = input => {
  let regex = /98([0-9]{3})/
  let groups = regex.exec(input)

  let decodedString = "sunshine: " + groups[1] + " minutes"
  return decodedString
}

const hourlyTempDewDecoder = input => {
  let regex = /T([0-1])([0-9]{3})([0-1])([0-9]{3})/
  let groups = regex.exec(input)
  let tempSign = groups[1]
  let temperature = groups[2]
  let dewSign = groups[3]
  let dewpoint = groups[4]

  const sign = val => { return val === "0" ? "" : "-" }

  let decodedString = "temperature/dewpoint: " +
    sign(tempSign) + temperature.substring(0, 2) + "." + temperature.substring(2, 3) + "°C/" +
    sign(dewSign) + dewpoint.substring(0, 2) + "." + dewpoint.substring(2, 3) + "°C"

  return decodedString
}

const sixHourMaxTemperatureDecoder = input => {
  let regex = /1([0-1])([0-9]{3})/
  let groups = regex.exec(input)

  let tempSign = groups[1]
  let temperature = groups[2]

  const sign = val => { return val === "0" ? "" : "-" }

  let decodedString = "6-hour max temperature: " +
    sign(tempSign) + temperature.substring(0, 2) + "." + temperature.substring(2, 3) + "°C"

  return decodedString
}

const sixHourMinTemperatureDecoder = input => {
  let regex = /2([0-1])([0-9]{3})/
  let groups = regex.exec(input)

  let tempSign = groups[1]
  let temperature = groups[2]

  const sign = val => { return val === "0" ? "" : "-" }

  let decodedString = "6-hour min temperature: " +
    sign(tempSign) + temperature.substring(0, 2) + "." + temperature.substring(2, 3) + "°C"

  return decodedString
}

const twentyFourMaxMinTemperatureDecoder = input => {
  let regex = /4([0-1])([0-9]{3})([0-1])([0-9]{3})/
  let groups = regex.exec(input)
  let minSign = groups[3]
  let minTemperature = groups[4]
  let maxSign = groups[1]
  let maxTemperature = groups[2]

  const sign = val => { return val === "0" ? "" : "-" }

  let decodedString = "24 hour min-max temperature: " +
    sign(minSign) + minTemperature.substring(0, 2) + "." + minTemperature.substring(2, 3) + "°C to " +
    sign(maxSign) + maxTemperature.substring(0, 2) + "." + maxTemperature.substring(2, 3) + "°C"

  return decodedString
}

const threeHourPressureTendencyDecoder = input => {
  let regex = /5([0-9])([0-9]{3})/
  let groups = regex.exec(input)
  let tendencyCode = groups[1]
  let pressureDifference = groups[2]

  const tendency = code => {
    switch(code) {
      case "0":
        return "increasing, then decreasing"
      case "1":
        return "increasing, then steady; or increasing then increasing more slowly"
      case "2":
        return "increasing steadily or unsteadily"
      case "3":
        return "decreasing or steady, then increasing; or increasing, then increasing more rapidly"
      case "4":
        return "steady"
      case "5":
        return "decreasing, then increasing"
      case "6":
        return "decreasing then steady; or decreasing then decreasing more slowly"
      case "7":
        return "decreasing steadily or unsteadily"
      case "8":
        return "steady or increasing, then decreasing; or decreasing then decreasing more rapidly"
      default:
        return code
    }
  }
  let decodedString = "3 hour pressure tendency: " + tendency(tendencyCode) + ", " +
    pressureDifference.substring(0, 2) + "." + pressureDifference.substring(2, 3) + " hPa"

  return decodedString
}

const notOperableSensorDecoder = input => {
  let regex = /(RVRNO|PWINO|PNO|FZRANO|TSNO|SLPNO)/
  let groups = regex.exec(input)
  let code = groups[1]
  let decodedString = ""
  switch(code) {
    case "RVRNO":
      decodedString += "runway visible range sensor"
      break
    case "PWINO":
      decodedString += "present weather sensor"
      break
    case "PNO":
      decodedString += "tipping bucket rain gauge"
      break
    case "FZRANO":
      decodedString += "freezing rain sensor"
      break
    case "TSNO":
      decodedString += "lightning detection sensor"
      break
    case "SLPNO":
      decodedString += "sea-level pressure sensor"
      break
    default:
  }

  return decodedString + " not operable"
}

const notOperableSecondaryLocationSensorDecoder = input => {
  let regex = /(VISNO|CHINO) ([A-Za-z0-9]*)/
  let groups = regex.exec(input)
  let indicator = groups[1]
  let location = groups[2]

  let decodedString = ""
  if(indicator == "VISNO") {
    decodedString += "visibility indicator at " + location + " not operable"
  } else {
    decodedString += "ceiling height indicator at " + location + " not operable"
  }
  return decodedString
}

const maintenanceIndicatorDecoder = input => {
  return "maintenance required"
}



// WEBPACK FOOTER //
// ./src/util/remarksDecoder.js